module.exports = __webpack_public_path__ + "static/media/io.9bdce175.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/io.svg
// module id = 2118
// module chunks = 0